var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"rounded-lg",attrs:{"elevation":"0"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Images')],1)],1)],1),_c('v-card',{staticClass:"rounded-lg my-8 px-8 py-8",attrs:{"elevation":"0"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('span',[_vm._v(_vm._s(_vm.info.data.comment))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }